import { useContext } from 'react';
import { GlobalModalContext } from '../contexts/GlobalModalContext';

export const useGlobalModalContext = () => useContext(GlobalModalContext);
